import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { Container, Breadcrumb,  Modal } from "react-bootstrap";
import { MyApi } from "../MyApi";
import useSEO from "../hooks/useSEO";

export default function ToursDetails({ setting }) {
  const { categorySlug, slug } = useParams();
const [showModal, setShowModal] = useState(false);
const [activeIndex, setActiveIndex] = useState(0);

// gallery modal
const openModal = (index) => {
  setActiveIndex(index);
  setShowModal(true);
};

const handleClose = () => setShowModal(false);

// const nextImage = () => {
//   setActiveIndex((prev) => (prev + 1) % gallery.length);
// };

// const prevImage = () => {
//   setActiveIndex((prev) =>
//     prev === 0 ? gallery.length - 1 : prev - 1
//   );
// };


// end
  const [tour, setTour] = useState(null);
  const [gallery, setGallery] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // 🔹 Fetch tour details + gallery
  useEffect(() => {
    const fetchTour = async () => {
      try {
        const res = await axios.get(
          `${MyApi.BASE_URL}tour-details/${categorySlug}/${slug}`,
          {
            headers: { Authorization: MyApi.SECRET_KEY },
          }
        );

        if (res.data.status) {
          setTour(res.data.data);
          setGallery(res.data.gallery || []);
        } else {
          setError(res.data.message || "Tour not found");
        }
      } catch (err) {
        console.error(err);
        setError("API request failed");
      } finally {
        setLoading(false);
      }
    };

    fetchTour();
  }, [categorySlug, slug]);

  // 🔹 SEO
  useSEO({
    title:
      tour?.meta_title ||
      tour?.productheading ||
      "Taxi Service in Varanasi | Best Day Tours & Travel Guide in Varanasi",
    description:
      tour?.meta_description ||
      tour?.productshortcontent ||
      "Explore the real Varanasi with Taxi Service in Varanasi.",
    keywords:
      tour?.meta_tags ||
      "Varanasi tours, Taxi Service in Varanasi, spiritual tours",
    canonical: window.location.href,
    ogImage: tour?.image_url || "",
  });

  if (loading) return <p className="text-center py-5">Loading...</p>;
  if (error) return <p className="text-center text-danger">{error}</p>;
  return (
    <>
      {/* 🔹 Breadcrumb Section */}
       <div className="BreadcrumbStyle">
             <Container>
                <h1>{tour.productname || tour.productname}</h1>
                <Breadcrumb>
                  <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>
                  <Breadcrumb.Item linkAs={Link} linkProps={{ to: `/services/${categorySlug}` }} >{categorySlug.replace(/-/g, " ")}</Breadcrumb.Item>
                  <Breadcrumb.Item active>{tour.productname || tour.productheading}</Breadcrumb.Item>
                </Breadcrumb>
              </Container>
          </div> 

      {/* 🔹 Tour Details */}
       <div className="pageStyle">
      <Container>
 <div className="d-flex flex-column flex-md-row align-items-start gap-4">
  {tour.image_url && (
    <div className="flex-shrink-0 w-40 w-md-auto">
      <img
        src={tour.image_url}
        alt={tour.productname}
        className="img-fluid w-100 rounded-4" 
      />
    </div>
  )}

  <div className="flex-grow-1"> 
 {(Number(tour?.price) > 0 || Number(tour?.net_wt) > 0) && (
                  <div className="d-none">
                    {Number(tour?.price) > 0 && (
                      <h5 className="text-danger">₹{tour.price}</h5>
                    )}

                  {Number(tour?.net_wt) > 0 && (() => {
                    const totalHours = Number(tour.net_wt);
                    const hours = Math.floor(totalHours);
                    const minutes = Math.round((totalHours - hours) * 60);

                    if (hours > 0 && minutes > 0) {
                      return <p>Duration <strong>{hours}h {minutes}m</strong></p>;
                    } else if (hours > 0) {
                      return <p>Duration <strong>{hours}h</strong></p>;
                    } else {
                      return <p>Duration <strong>{minutes}m</strong></p>;
                    }
                  })()}

                  </div>
                )}

          <div dangerouslySetInnerHTML={{ __html: tour.productcontent }} />

        
 
            <div>
            <div className="d-flex gap-2">
                <a
  href={`tel:${setting?.mobile}`}
  className="btn btn-success"
>
  <i className="fa-solid fa-phone-volume"></i>  
</a>
        <a
  href={`https://wa.me/919569234541?text=${encodeURIComponent(
    `Hi, I want details about ${tour.productname}.
    
Tour Link: ${window.location.href}`
  )}`}
  target="_blank"
  rel="noopener noreferrer"
  className="btn btn-danger "
>
  Book Now
</a>
<Link to="/contact-us" className="btn btn-primary">Enquire Now!</Link>
        </div>
        </div>
          </div>
          
        </div>
  {/* 🔹 Gallery */}
              {gallery.length > 0 && (
  <div className="mt-4">
    <h4 className="mb-3">
      {tour.productheading || tour.productname} Gallery
    </h4>

    <div className="row g-3">
      {gallery.map((img, index) => (
        <div className="col-6 col-md-4 col-lg-3" key={index}>
          <div
            className="gallery-item rounded-4 overflow-hidden"
            role="button"
            onClick={() => openModal(index)}
          >
            <img
              src={img.image_url}
              alt={`Gallery ${index + 1}`}
              className="img-fluid w-100"
              loading="lazy"
            />
          </div>
        </div>
      ))}
    </div>
  </div>
)}

      </Container>
      </div>


     <Modal
  show={showModal}
  onHide={handleClose}
  centered
  fullscreen="lg-down"   // 🔹 Fullscreen on mobile/small screens
  contentClassName="gallery-modal-content"
  backdropClassName="gallery-backdrop"
>
  <Modal.Body className="p-0 text-center position-relative">

    {/* Close button */}
    <button
      className="gallery-close-btn"
      onClick={handleClose}
      aria-label="Close"
    >
      ×
    </button>

    {/* Previous Button */}
    {/* <button className="gallery-nav gallery-prev" onClick={prevImage}>
      ‹
    </button> */}

    {/* Image */}
    <img
      src={gallery[activeIndex]?.image_url}
      alt="Gallery Preview"
      className="img-fluid shadow"
      style={{
        maxHeight: "90vh",
        maxWidth: "95vw",  // 🔹 width responsive
        objectFit: "contain",
      }}
    />

    {/* Next Button */}
    {/* <button className="gallery-nav gallery-next" onClick={nextImage}>
      ›
    </button> */}

  </Modal.Body>
</Modal>


    </>
  );
}
